import BlogSection from "../../components/blog/BlogSection";
import Certificates from "../../components/certificates/Certificates";
import Education from "../../components/education/Education";
import Experience from "../../components/experience/Experience";
import GithubHighlights from "../../components/github/GithubHighlights";
import Header from "../../components/header/Header";
import Interests from "../../components/interests/Interests";
import Projects from "../../components/projects/Projects";
import React from "react";
import Skills from "../../components/skills/Skills";

const MainPage = () => {
  return (
    <>
      <div className="container p-0 pt-5">
        <Header />
        <hr className="m-0" />
        <Education />
        <hr className="m-0" />
        <Experience />
        <hr className="m-0" />
        <Projects />
        <hr className="m-0" />
        <GithubHighlights />
        <hr className="m-0" />
        <Skills />
        <hr className="m-0" />
        <Certificates />
        <hr className="m-0" />
        <Interests />
        <hr className="m-0" />
        <BlogSection />
      </div>
    </>
  );
};

export default MainPage;
